import { ActivityTaskStatus } from '../../../../tokens-and-interfaces';

export const STANDARD_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm";
export const DEFAULT_TASK_STATUS = ActivityTaskStatus.Open;
